// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2lD4C","bigColWidth":"Table_bigColWidth__2HKu4","biggerColWidth":"Table_biggerColWidth__155sf","row":"Table_row__12MGK","col":"Table_col___vliz"};